"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'register.name.placeholder': '输入您的姓名',
};
